<script setup lang="ts">
const props = defineProps<{ dates: Date[] }>()

const date = computed(() => props.dates[0])
</script>

<template>
  <figure v-if="date" class="-gap-12 flex max-w-fit flex-col items-center rounded-2xl bg-white p-4 pt-2 sm:min-w-28">
    <span
      v-if="dates.length === 1"
      class="text-3xl sm:text-6xl"
      v-text="date.getDate()"
    />
    <IconsGraphicsStarIcon
      v-else
      aria-hidden="true"
      class="my-4 scale-125"
    />
    <span class="text-lg uppercase" v-text="date.toLocaleDateString('nb-NO', { month: 'short' })" />
  </figure>
</template>
